import React, { useMemo, useState } from 'react';
import Styles from './ModalInstallments.css';
import Select from '../../widgets/Select/Select';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import Button from '../../widgets/Button/Button';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { useScroll } from '../../../../utils/useLayout';
import Modal from '../../widgets/Modal/Modal';
import { useUpdateInstallments } from '../../api/use-update-installments';
import { getErrorData } from '../../shared/utils/error';

const Wrapper = ({ children, modal = false, setOpen, open }) => {
  if (modal) {
    return (
      <Modal open={open} setOpen={setOpen} contentFill>
        {children}
      </Modal>
    );
  }

  return <>{children}</>;
};

function ModalInstallments({ offer, onUpdateInstallmentCount }) {
  const {
    setModalInstallments,
    modalInstallments,
    isMobile,
    token,
    showErrorStep,
    EventHandler,
    loading,
  } = useSimuladorEnergiaSolarState();
  const { scrollToSelector } = useScroll();
  const [selectedOption, setSelectedOption] = useState();

  const update = useUpdateInstallments({ token });

  const installOptions = useMemo(() => {
    if (!offer || !offer?.installmentOptions) return [];

    const opts = offer?.installmentOptions || [];
    const list = opts.filter((o) => !o.loaded);

    return list.map((v) => ({
      value: `${v.quantity}`,
      label: `${v.quantity}x`,
    }));
  }, [offer]);

  const handleSubmit = async () => {
    try {
      await update.mutateAsync({
        installments: Number(selectedOption),
      });

      if (onUpdateInstallmentCount) {
        onUpdateInstallmentCount(Number(selectedOption));
      }

      setTimeout(() => {
        setModalInstallments(false);
        EventHandler.emit('refetch-best-offer');

        if (isMobile) {
          scrollToSelector('.proposal .text-choose-installment');
        }
      }, 100);
    } catch (error) {
      showErrorStep({ ...getErrorData(error), ctx: 'api-update-installments-modal' });
    }
  };

  if (!modalInstallments) return null;

  return (
    <Wrapper
      modal={!isMobile}
      open={modalInstallments}
      setOpen={update.isPending || loading ? null : setModalInstallments}
    >
      <div className="modal-installments">
        <ContainerHome24>
          <p className="text-title-desk">Quantas parcelas deseja?</p>
          <p className="text-title">Selecione um prazo para calcular o valor das parcelas:</p>

          <Select
            label="Prazo"
            options={installOptions}
            value={selectedOption}
            handleValueChange={setSelectedOption}
          />

          <div className="info-box">
            <img src="assets/simulador-energia-solar/jornada/proposal-installment.svg" alt="" />
            <p className="text-desc">Digite um prazo para simular as parcelas.</p>
          </div>

          <div className="btn-wrapper">
            <Button
              variant="red"
              disabled={!selectedOption || update.isPending || loading}
              onClick={handleSubmit}
            >
              {isMobile ? 'Continuar' : 'Confirmar prazo'}
            </Button>
            <Button
              disabled={loading || update.isPending}
              variant="white"
              onClick={() => {
                setSelectedOption(undefined);
                setModalInstallments(false);
                scrollToSelector('.proposal .select-installment');
              }}
            >
              Voltar
            </Button>
          </div>
        </ContainerHome24>
      </div>
      <style jsx>{Styles}</style>
    </Wrapper>
  );
}

export default ModalInstallments;
